// extracted by mini-css-extract-plugin
export default {"radio_button":"Selector_radio_button__zhOdJ","label":"Selector_label__KvsAn","selector_item":"Selector_selector_item__sQlE-"};